// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";

function TbHexName(Props) {
  var lang = Props.lang;
  var nameParts = Props.nameParts;
  var fontSize;
  switch (lang) {
    case "ja" :
    case "zh" :
        fontSize = "14px";
        break;
    default:
      var len = nameParts.join("").length;
      fontSize = len < 12 ? "15px" : (
          len < 15 ? "14px" : "13px"
        );
  }
  return React.createElement("g", {
              transform: "translate(44, 66)"
            }, Belt_Array.mapWithIndex(nameParts, (function (idx, part) {
                    return React.createElement("text", {
                                key: String(idx),
                                className: CssJs.merge([
                                      "pointer-events-none",
                                      CssJs.style([T.sm_([CssJs.unsafe("textShadow", "-1px 0 2px #000, 0 1px 2px #000, 1px 0 2px #000, 0 -1px 2px #000")])])
                                    ]),
                                fill: "white",
                                fontSize: fontSize,
                                textAnchor: "middle",
                                y: nameParts.length < 2 ? "0" : String((((idx + 2 | 0) - nameParts.length | 0) << 4) - 3 | 0)
                              }, part);
                  })));
}

var make = TbHexName;

export {
  make ,
  
}
/* T Not a pure module */
